import EmbedForm from "../../../../src/components/EmbedForm";
import * as React from 'react';
export default {
  EmbedForm,
  React
};